import { render } from "./Main.vue?vue&type=template&id=7f92d610&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=7f92d610&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f92d610"

export default script